const AddressIcon = () => {
    return (
        <i className="fad fa-location"></i>
    );
}

export default AddressIcon;